import { apiCall, API_CONFIG } from './api';

export const serverErrorAPI = {
  // Get server errors by filter
  getServerErrors: async (page = 1, limit = 20, dateFilter = 'today', startDate = '', endDate = '') => {
    try {
      const queryParams = new URLSearchParams({
        page,
        limit,
        dateFilter
      });

      if (startDate) queryParams.append('startDate', startDate);
      if (endDate) queryParams.append('endDate', endDate);

      const response = await apiCall(`${API_CONFIG.ENDPOINTS.SERVER_ERRORS}?${queryParams.toString()}`, {
        method: 'GET'
      });

      if (response.success) {
        return {
          success: true,
          data: response.data?.errors,
          pagination: response.data?.pagination,
          msg: response.msg
        };
      } else {
        return {
          success: false,
          data: [],
          pagination: null,
          message: response.msg || 'Failed to fetch server errors'
        };
      }
    } catch (error) {
      console.error('Error fetching server errors:', error);
      return {
        success: false,
        data: [],
        pagination: null,
        message: error.message || 'Network error occurred'
      };
    }
  },

  getClientErrorReports: async (page = 1, limit = 20, dateFilter = 'all', startDate = '', endDate = '') => {
    try {
      const queryParams = new URLSearchParams({
        page,
        limit,
        dateFilter,
      });

      if (startDate) queryParams.append('startDate', startDate);
      if (endDate) queryParams.append('endDate', endDate);

      const response = await apiCall(`${API_CONFIG.ENDPOINTS.CLIENT_ERROR_REPORTS}?${queryParams.toString()}`, {
        method: 'GET',
      });

      if (response.success) {
        return {
          success: true,
          data: response.data?.errors,
          pagination: response.data?.pagination,
          msg: response.msg,
        };
      }

      return {
        success: false,
        data: [],
        pagination: null,
        message: response.msg || 'Failed to fetch client error reports',
      };
    } catch (error) {
      console.error('Error fetching client error reports:', error);
      return {
        success: false,
        data: [],
        pagination: null,
        message: error.message || 'Network error occurred',
      };
    }
  },
};
